export const outerHeight = el => {
  if (el) {
    var height = el.offsetHeight;
    var style = getComputedStyle(el);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
  }
  return height || 0;
};

export const applyMapHeight = () => {
  const descHeight = outerHeight(document.querySelector(".content .desc"));
  const formHeight = outerHeight(document.querySelector(".content .form-xs"));
  const windowHeight = window.innerHeight;
  const totalHeight = descHeight + formHeight;
  const remainHeight = windowHeight - totalHeight;

  if (document.querySelector(".map")) {    
    document.querySelector(".map").style.height = remainHeight + 'px';
  }
};



// WEBPACK FOOTER //
// ./src/components/home/map/util.js